import { Button, PlaybackToggleButton, ControlBar } from 'bitmovin-player-ui';
import { rewind, forward } from '../handlers/timecontrolhandlers';
export function createMiddleButtons(playerContext) {
    const bigPlayToggleButton = new PlaybackToggleButton({
        cssClass: 'ui-playbacktogglebutton'
    });
    const bigRewindButton = createRewindButton(playerContext);
    const bigForwardButton = createForwardButton(playerContext);
    return new ControlBar({
        components: [bigRewindButton, bigPlayToggleButton, bigForwardButton],
        cssClasses: ['controlbar-middle']
    });
}
export function createRewindButton(playerContext) {
    const { player } = playerContext;
    const rewindButton = new Button({
        cssClass: 'ui-rewindbutton bmpui-ui-button',
        ariaLabel: 'Spoel 10 seconden terug'
    });
    rewindButton.onClick.subscribe(() => {
        rewind(player);
    });
    return rewindButton;
}
export function createForwardButton(playerContext) {
    const { player } = playerContext;
    const forwardButton = new Button({
        cssClass: 'ui-forwardbutton bmpui-ui-button',
        ariaLabel: 'Spoel 10 seconden vooruit'
    });
    forwardButton.onClick.subscribe(() => {
        forward(player);
    });
    return forwardButton;
}
export function createPlayNextButton(player, npoplayer) {
    const playNextButton = new Button({
        cssClass: 'ui-textbutton ui-playNextButton bmpui-ui-button',
        text: '<span class="bmpui-ui-textbutton-icon bmpui-ui-textbutton-icon-play"></span> Volgende aflevering',
        ariaLabel: 'Volgende aflevering',
        hidden: false,
        acceptsTouchWithUiHidden: true
    });
    playNextButton.onClick.subscribe(() => {
        if (player != undefined) {
            npoplayer.doPlayNext();
        }
    });
    return playNextButton;
}
export function createCancelPlayNextButton(player, npoplayer) {
    const cancelPlayNextButton = new Button({
        cssClass: 'ui-textbutton ui-cancelPlayNextButton bmpui-ui-button',
        text: 'Annuleer',
        ariaLabel: 'Annuleer',
        hidden: false,
        acceptsTouchWithUiHidden: true
    });
    cancelPlayNextButton.onClick.subscribe(() => {
        if (player != undefined) {
            npoplayer.cancelPlayNextScreen();
        }
    });
    return cancelPlayNextButton;
}
export function createskipIntroButton(player) {
    const skipIntroButton = new Button({
        cssClass: 'ui-textbutton ui-skipintrobutton bmpui-ui-button bmpui-hidden',
        text: 'Intro overslaan',
        ariaLabel: 'Intro overslaan',
        hidden: true
    });
    skipIntroButton.onClick.subscribe(() => {
        if (player != undefined) {
            player.seek(96);
        }
    });
    return skipIntroButton;
}
export function createGoBackLiveButton(player) {
    const goBackLiveButton = new Button({
        cssClass: 'ui-textbutton ui-backtolivebutton bmpui-ui-button',
        text: 'Terug naar live',
        ariaLabel: 'Terug naar live',
        hidden: true
    });
    goBackLiveButton.onClick.subscribe(() => {
        if (player != undefined && player.isLive()) {
            player.timeShift(0);
        }
    });
    return goBackLiveButton;
}
export function createWatchFromStartButton(player, npoplayer) {
    const watchFromStartButton = new Button({
        cssClass: 'ui-textbutton ui-watchfromstartbutton bmpui-ui-button',
        text: 'Kijk vanaf het begin',
        ariaLabel: 'Kijk vanaf het begin',
        hidden: true
    });
    watchFromStartButton.onClick.subscribe(() => {
        if (player.isLive() ?? false)
            npoplayer.watchFromStart();
        if (npoplayer.uiComponents.watchFromStartButton)
            npoplayer.uiComponents.watchFromStartButton.hide();
    });
    npoplayer.uiComponents.watchFromStartButton = watchFromStartButton;
    return watchFromStartButton;
}
